/**
 * 接收promise，支持await调用的同时，接收到resolve&reject
 * 返回一个数组，数组
 * @template T
 * @param {Promise<{data:T}>} promise
 * @returns {Promise<[Error|null,T|null]>}
 * @example const data = await resolveWithError(func(param))
 */
export async function resolveWithError(promise) {
    const arr = [null];
    try {
        const res = await promise;
        arr[1] = res;
    } catch (error) {
        arr[0] = error;
    }
    return arr;
}
